<template>
  <div style="height: 100%">
    <div class="table-row">
      <div class="table-col">
        <div class="table-box">
          <div class="right-title">经营状况</div>
          <div id="awardsdata" style="width: 100%; height: calc(100% - 0.2rem)"></div>
        </div>
      </div>
      <div class="table-col" style="margin-left: 0.1rem">
        <div class="table-box">
          <div class="right-title">人才招聘</div>
          <div id="chartPie" style="width: 100%; height: calc(100% - 0.2rem)"></div>
        </div>
      </div>
    </div>
    <div class="table-box" style="height: 48%;">
      <div class="right-title">纳税信息</div>
      <div id="zhexianline" style="width: 100%; height: calc(100% - 0.2rem)"></div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";
import * as echarts from "echarts";
export default {
  props: {
    form: Object
  },
  data() {
    return {};
  },
  mounted() {
    this.getInvestList();
    this.geRecruitList();
  },
  methods: {
    geRecruitList(){
      api.getRecruitList({
        firmId: this.form.id
      }).then(res => {
        let positionList = [];
        res.rows.forEach(item => {
          positionList.push({
            value: 1,
            name: item.position
          })
        })
        this.drawPieChart(positionList);
      })
    },
    getInvestList() {
      api.getInvestList({
        firmId: this.form.id
      }).then(res => {
        let monthList = [];
        let taxList = [];
        let incomeList = [];
        let paidList = [];
        res.rows.forEach(item => {
          monthList.push(item.year + '-' + item.month);
          taxList.push(item.tax)
          incomeList.push(item.income)
          paidList.push(item.paid)
        })
        this.zhexian(monthList, taxList);
        this.chart(monthList, incomeList, paidList);
      })
    },
    // 折线图
    zhexian(monthList, taxList) {
      this.chartPie = echarts.init(document.getElementById("zhexianline"));
      this.chartPie.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["纳税金额"],
        },

        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: monthList,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "纳税金额",
            type: "line",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: taxList,
          },
        ],
      });
    },
    // 饼状图
    drawPieChart(positionList) {
      this.chartPie = echarts.init(document.getElementById("chartPie"));
      this.chartPie.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        legend: {
          orient: "vertical",
          left: "right",
          data: positionList.map(item => item.name),
          textStyle:{
                color:"#fff"
        }
        },
        series: [
          {
            name: "招聘类型",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: positionList,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    // 柱状图
    chart(xAxis, data1, data2 ) {
      let chart = echarts.init(document.getElementById("awardsdata"));
      chart.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          x: "500px",
          y: "480px",
          data: ["收入", "支出"],
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
          },
        ],
        yAxis: [{ type: "value" }],
        series: [
          {
            name: "收入",
            type: "bar",
            barWidth: 15,
            data: data1,
          },
          {
            name: "支出",
            type: "bar",
            barWidth: 15,
            data: data2,
          },
        ],
      });
    },
  },
};
</script>

<style scoped lang="scss">
.table-row {
  display: flex;
//   align-items: center;
  height: 50%;
  .table-col {
    width: 50%;
    height: 90%;
  }
}
.table-box {
  border: 1px solid #01c5f3;
  padding: 0.05rem;
  height: 100%;
  position: relative;
  .right-title {
    border-left: 2px solid #01c5f3;
    padding: 0 0.1rem;
    font-size: 0.12rem;
    font-weight: 550;
  }
  
}
.select{
    position: absolute;
    top: 0.1rem;
    right: .1rem;
    width: 20%;
  }
</style>
